module.exports = __webpack_public_path__ + "static/media/17-4.0a3e171f.mp3";